import MerchantRoleApi from '@/api/merchant-role'

const state = { }

const mutations = { }

const actions = {
  async list ({ commit }) {
    const result = await MerchantRoleApi.list()
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantRoleApi.insert(data)
    return result
  },
  async update ({ commit }, data) {
    const result = await MerchantRoleApi.update(data)
    return result
  },
  async enable ({ commit }, roleId) {
    const result = await MerchantRoleApi.enable(roleId)
    return result
  },
  async disable ({ commit }, roleId) {
    const result = await MerchantRoleApi.disable(roleId)
    return result
  },
  async getRolePermissions ({ commit }, roleId) {
    const result = await MerchantRoleApi.getRolePermissions(roleId)
    return result
  },
  async addRolePermissions ({ commit }, params) {
    const result = await MerchantRoleApi.addRolePermissions(params)
    return result
  },
  async removeRolePermissions ({ commit }, params) {
    const result = await MerchantRoleApi.removeRolePermissions(params)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-role.js